import { render, staticRenderFns } from "./CartInfoRegistration.vue?vue&type=template&id=21502622&scoped=true&"
import script from "./CartInfoRegistration.vue?vue&type=script&lang=js&"
export * from "./CartInfoRegistration.vue?vue&type=script&lang=js&"
import style0 from "./CartInfoRegistration.vue?vue&type=style&index=0&id=21502622&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21502622",
  null
  
)

export default component.exports